import { DatePipe, formatNumber } from "@angular/common";
import { Injectable } from "@angular/core";
import { saveAs } from "file-saver";
import { isNil } from "lodash";

@Injectable()
export class CsvGeneratorService {
    export(fileName: string, data: any[], columns: CsvColumn[]): void {
        let blob = this.createBlob(data, columns);
        saveAs(blob, fileName + ".csv");
    }

    private createBlob(data: any[], columns: CsvColumn[]): Blob {
        let replacer = (key, value) => (value === null ? "" : value);
        let csv = data.map((row) =>
            columns
                .map((header) => {
                    let returnedData = row[header.value];
                    let isNumber = false;

                    if (!isNil(row[header.value])) {
                        if (header.type == "Date") {
                            let date = new Date(row[header.value]);
                            if(date == null)
                                returnedData = new DatePipe("en-US").transform(
                                    date,
                                    "yyyy-MM-dd"
                                );
                        } else if (header.type == "Number") {
                            isNumber = true;
                            returnedData = formatNumber(
                                +row[header.value],
                                "en-US",
                                "1.0-2"
                            );
                        } else if (header.type == "Percentage") {
                            isNumber = true;
                            returnedData =
                                formatNumber(
                                    +row[header.value],
                                    "en-US",
                                    "1.0-2"
                                ) + "%";
                        } else if (header.type == "Boolean") {
                            returnedData = row[header.value] ? "Yes" : "No";
                        } else if (Array.isArray(row[header.value])) {
                            returnedData = row[header.value].join(",");
                        }
                    }

                    return JSON.stringify(returnedData, replacer);
                })
                .join(",")
        );

        csv.unshift(columns.map((x) => x.header).join(","));

        let csvArray = csv.join("\r\n");

        return new Blob([csvArray], { type: "text/csv" });
    }
}

export class CsvColumn {
    value: string;
    header: string;
    type: "Date" | "Number" | "Percentage" | "Boolean" | "String";
}
